// tslint:disable:max-line-length

import React from 'react';

export const ActionLocate = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M16 0l-16 8 6 2 2 6 8-16z" />
    </svg>
  );
};
